import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import Styles from './ProjectRemoveButton.styles';
import JumperModal from '../../JumperModal/JumperModal';

class ProjectRemoveButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  openModal() {
    this.setState({
      isModalOpen: true,
    });
  }

  handleSubmit(event) {
    this.props.onSubmit(event);
    this.handleClose();
  }

  handleClose() {
    this.setState({
      isModalOpen: false,
    });
  }
  render() {
    const itemStr = this.props.selected.length > 1 ? 'items' : 'item';
    return (
      <div>
        <div role="button" tabIndex={-1} style={Styles.button} onClick={this.openModal}>
          Remove {itemStr}
        </div>
        <JumperModal
          open={this.state.isModalOpen}
          handleClose={this.handleClose}
          handleSubmit={this.handleSubmit}
          title={`Remove ${itemStr}`}
        >
          {`Are you sure you want to remove selected ${itemStr}`}
        </JumperModal>
      </div>
    );
  }
}

ProjectRemoveButton.propTypes = {
  selected: PropTypes.arrayOf(Object).isRequired,
  onSubmit: PropTypes.func.isRequired,
};

ProjectRemoveButton.defaultProps = {};

export default Radium(ProjectRemoveButton);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectRemoveButton/ProjectRemoveButton.js